import React, { useEffect, useState } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMyAccount } from '../../../../../data/hooks/sessionHooks';
import Button from '../../../../elements/Button/Button';

const RecoverPasswordFlow = (props) => {
    const { onCancel } = props,
        [message, setMessage] = useState(''),
        user = useMyAccount(),
        { email } = user,
        i18n = useI18n();

    useEffect(() => {
        let waiting = true;

        async function recoverPassword() {
            try {
                await app.api.session.recoverPassword(email);
                if (waiting)
                    setMessage(i18n['message.forgottenPasswordRecovered']);
            } catch (err) {
                console.warn(err);
                if (waiting) onCancel();
            }
        }
        recoverPassword();

        return () => (waiting = false);
    }, [email]);

    return (
        <>
            <div className="content" style={{ minHeight: 200 }}>
                <p className="text-center">{message}</p>
            </div>
            <div className="content">
                <Button href=".." primary block>
                    {i18n['label.continue']}
                </Button>
            </div>
        </>
    );
};

export default RecoverPasswordFlow;
